import ReactDOM from 'react-dom';
import Admin from "./router/admin";

ReactDOM.render(
    <Admin />,
  document.getElementById('root')
);


